import React, {useEffect, useState} from 'react';
import {useNavigate} from 'react-router-dom';
import Box from '@mui/material/Box';
import MenuItem from '@mui/material/MenuItem';
import {Container, Stack} from "@mui/material";
import Paper from '@mui/material/Paper';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Menu from '@mui/material/Menu';
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import {DataGrid} from "@mui/x-data-grid";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import Button from "@mui/material/Button";


const About = () => {

    const token = localStorage.getItem('token');

    const [anchorEl, setAnchorEl] = useState(null);
    const [history, setHistory] = useState('All');
    const [rows, setRows] = useState([]);
    const navigate = useNavigate();
    const [movie, setMovie] = useState([])
    const [imageUrl, setImageUrl] = useState([]);
    const [dateSeen, setDateSeen] = useState(null);
    const [movieName, setMovieName] = useState(null);
    const [directorName, setDirectorName] = useState(null);
    const [genre, setGenre] = useState('All')
    const [genres , setGenres] = useState([])
    const [movieNameError, setMovieNameError] = useState(false);
    const [movieNameHelperText, setMovieNameHelperText] = useState('');
    const [directorNameError, setDirectorNameError] = useState(false);
    const [directorNameHelperText, setDirectorNameHelperText] = useState('');
    const [minRunningTime, setMinRunningTime] = useState('')
    const [minRunningTimeError, setMinRunningTimeError] = useState(false);
    const [minRunningTimeHelperText, setMinRunningTimeHelperText] = useState('');
    const [maxRunningTime, setMaxRunningTime] = useState('')
    const [maxRunningTimeError, setMaxRunningTimeError] = useState(false);
    const [maxRunningTimeHelperText, setMaxRunningTimeHelperText] = useState('');

    const open = Boolean(anchorEl);

    const isAdmin = localStorage.getItem('x') === "1";

    const columns = [
        //{ field: 'Id', headerName: 'ID', width: 70 },
        { field: 'Year', headerName: 'Year', width: 60 },
        { field: 'Festival', headerName: 'Festival', width: 140 },
        { field: 'Title', headerName: 'Title', width: 260 },
        { field: 'Director', headerName: 'Director', width: 200 },
        { field: 'Genre', headerName: 'Genre', width: 150 },
        { field: 'Runtime', headerName: 'Runtime', type: 'number', width: 70 },
        { field: 'NoNominations', headerName: 'Nominations', type: 'number', width: 100 },
        { field: 'NoAwards', headerName: 'Awards', type: 'number', width: 100 },
    ];

    const getRowIdFromInternalId = (row) => row.Id;

    const paginationModel = { page: 0, pageSize: 10 };

    const handleMovieNameChange = (event) => {
        setMovieName(event.target.value);
    };

    const handleDirectorNameChange = (event) => {
        setDirectorName(event.target.value);
    };

    const handleGenreChange = (event) => {
        setGenre(event.target.value);
    };

    const handleMinRunningTimeChange = (event) => {
        setMinRunningTime(event.target.value);
    };

    const handleMaxRunningTimeChange = (event) => {
        setMaxRunningTime(event.target.value);
    };

    const handleHistoryChange = (event) => {
        setHistory(event.target.value);
    };

    const handleSearch = () => {
        console.log("Search...");
        var errors = false;

        if (hasNoNumbersOrPunctuation(movieName)) {
            setMovieNameError(false);
            setMovieNameHelperText('');
        } else {
            setMovieNameError(true);
            setMovieNameHelperText('Cannot include numbers or special characters');
            errors = true;
        }
        if (hasNoNumbersOrPunctuation(directorName)) {
            setDirectorNameError(false);
            setDirectorNameHelperText('');
        } else {
            setDirectorNameError(true);
            setDirectorNameHelperText('Cannot include numbers or special characters');
            errors = true;
        }
        if (containsOnlyNumbers(minRunningTime)) {
            setMinRunningTimeError(false);
            setMinRunningTimeHelperText('');
        } else {
            setMinRunningTimeError(true);
            setMinRunningTimeHelperText('Has to be numeric');
            errors = true;
        }
        if (containsOnlyNumbers(maxRunningTime)) {
            setMaxRunningTimeError(false);
            setMaxRunningTimeHelperText('');
        } else {
            setMaxRunningTimeError(true);
            setMaxRunningTimeHelperText('Has to be numeric');
            errors = true;
        }
        if (!errors) {
            console.log('Searching');
            retrieveTableData(movieName, directorName, genre, history, minRunningTime, maxRunningTime);
            clearMovieDetail();
        }
    }

    const handleMenuClick = (event) => {
        setAnchorEl(event.currentTarget);
    }

    const handleMenuClose = () => {
        setAnchorEl(null);
    }

    const handleRowClick = (params) => {
        console.log('Row id:', params.id);
        retrieveMovieData(params.id);
        retrieveSeenDate(params.id);
    };

    const handleDateClear = () => {
        setDateSeen(null);
    }

    const clearMovieDetail = () => {
        console.log("Entering clearMovieDetail")
        const movie = {
            AwardCategory: "",
            NominationCategory: "",
            Overview: "",
            Posterpath: "",
            RtScore: "",
            ImdbScore: ""
        }
        setMovie(movie);
        setImageUrl("");
        setDateSeen(null);
        console.log("Leaving clearMovieDetail");
    }

    const handleDateChange = async (newValue) => {
        setDateSeen(newValue);
        const dateString = newValue ? newValue.format('MM/DD/YYYY') : '';
        console.log('New date: ', dateString);
        try {
            const movieId = movie.ID.toString();
            console.log("Movie id: ", movieId);

            const response = await fetch('/api/updateSeenDate', {
                method: 'POST',
                headers: {'Authorization': 'Bearer ' + token},
                body: JSON.stringify({movieId, dateString}),
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const json = await response.json();
            console.log('Response: ', json);

        } catch (err) {
            console.error(err);
        }
    }

    const retrieveTableData = async (movieName, directorName, genre, history, minRunningTime, maxRunningTime) => {
        try {
            const baseUrl = '/api/advancedSearchMovies';
            const url = new URL(baseUrl, window.location.origin);
            url.searchParams.append('movieName', movieName);
            url.searchParams.append("directorName", directorName);
            url.searchParams.append("genre", genre);
            url.searchParams.append("history", history);
            url.searchParams.append("minRunningTime", minRunningTime);
            url.searchParams.append("maxRunningTime", maxRunningTime);

            console.log('movieName:', movieName);
            console.log('directorName:', directorName);
            console.log('genre:', genre);
            console.log('history:', history);
            console.log('minRunningTime:', minRunningTime);
            console.log('maxRunningTime:', maxRunningTime);

            const response  = await fetch(url,{
                method: 'GET',
                headers: {'Authorization': 'Bearer ' + token}
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const json = await response.json();
            // console.log('Table data', json);
            setRows(json);

        } catch (err) {
            console.error(err);
        }
    };

    const retrieveMovieData = async (movieId)  => {
        try {
            const baseUrl = '/api/getMovie';
            const url = new URL(baseUrl, window.location.origin);
            url.searchParams.append('movieId', movieId);
            const response  = await fetch(url,{
                method: 'GET',
                headers: {'Authorization': 'Bearer ' + token}
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const json = await response.json();
            console.log('Movie data', json);
            setMovie(json);
            const posterPath = json.PosterPath;
            console.log('Poster URL: ', posterPath);
            const fullPosterPath = "https://image.tmdb.org/t/p/w185" + posterPath;
            setImageUrl(fullPosterPath);
            console.log('Full poster path: ', fullPosterPath);
        } catch (err) {
            console.error(err);
        }
    }

    const retrieveSeenDate = async(movieId) => {
        console.log("Entering retrieveSeenDate");
        const baseUrl = '/api/getSeenDate';
        const url = new URL(baseUrl, window.location.origin);
        url.searchParams.append('movieId', movieId.toString());
        const response  = await fetch(url,{
            method: 'GET',
            headers: {'Authorization': 'Bearer ' + token}
        });
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const json = await response.json();
        const seenDate = json.Date;
        console.log('Seen Data: ', seenDate);
        if (seenDate === '') {
            setDateSeen(null);
        }
        else {
            const format = "MM/DD/YYYY";
            const dateObject = dayjs(seenDate, format);
            setDateSeen(dateObject);
        }
    }

    const handleMenuLogout = () => {
        handleMenuClose();
        localStorage.setItem('token', "");
        localStorage.setItem('email', "");
        localStorage.setItem('x', "");
        navigate('/');
    }

    const handleMenuSearch = () => {
        handleMenuClose();
        navigate('/landing')
    }

    const handleMenuAbout = () => {
        handleMenuClose();
        navigate("/about")
    }

    const handleMenuUserManagement = () => {
        handleMenuClose();
        navigate("/userManagement")
    }

    const handleMenuProfile = () => {
        handleMenuClose();
        navigate("/profile")
    }

    const hasNoNumbersOrPunctuation = (str) => {
        // The pattern checks if the string starts (^) and ends ($) with
        // one or more (+) characters from the allowed set [A-Za-z\s].
        // The allowed set includes all letters (case-sensitive) and whitespace characters.
        const regex = /^[A-Za-z\s]*$/;
        return regex.test(str);
    }

    const containsOnlyNumbers = (str) => {
        if (str.length == 0) return true;
        const regex = /^\d+$/;
        return regex.test(str);
    }

    const retrieveGenres = async ()  => {
        try {
            const response  = await fetch(`/api/getGenres`,{
                method: 'GET',
                headers: {'Authorization': 'Bearer ' + token}
            });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const json = await response.json();
            console.log('Genre data', json);
            setGenres(json);
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        retrieveGenres();
    }, []);
    return (
        <Container component="main" maxWidth="lg">
            <Box sx={{ flexGrow: 1 }}>
                <AppBar position="static">
                    <Toolbar>
                        <IconButton
                            size="large"
                            edge="start"
                            color="inherit"
                            aria-label="menu"
                            sx={{ mr: 2 }}
                            aria-haspopup="true"
                            aria-controls={open ? 'popup-menu' : undefined}
                            aria-expanded={open ? 'true' : undefined}
                            onClick={handleMenuClick}
                        >
                            <MenuIcon />
                        </IconButton>
                        {/* The actual MUI Menu component */}
                        <Menu
                            id="popup-menu"
                            anchorEl={anchorEl}
                            open={open}
                            onClose={handleMenuClose}
                            // Keep the menu mounted in the DOM when closed for potential performance benefits
                            // You can remove keepMounted if you prefer it to unmount
                            keepMounted
                            MenuListProps={{
                                'aria-labelledby': 'menu-button',
                            }}
                        >
                            {/* Menu Items */}
                            <MenuItem onClick={handleMenuAbout}>
                                <Typography variant="inherit">About</Typography>
                            </MenuItem>
                            <MenuItem onClick={handleMenuProfile}>
                                <Typography variant="inherit">Profile</Typography>
                            </MenuItem>
                            <MenuItem onClick={handleMenuSearch}>
                                <Typography variant="inherit">Search</Typography>
                            </MenuItem>
                            {isAdmin && <MenuItem onClick={handleMenuUserManagement}><Typography variant="inherit">User Management</Typography></MenuItem>}
                            <MenuItem onClick={handleMenuLogout}>
                                <Typography variant="inherit">Logout</Typography>
                            </MenuItem>
                        </Menu>

                        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
                            Advanced Search
                        </Typography>
                    </Toolbar>
                </AppBar>
            </Box>
            <Paper sx={{ flexGrow: 1, width: '100%', padding: 4, marginTop: 2}}>
                <Grid container sx={{ ml: '80px' }} spacing={3} direction="row" alignItems="center" justifyContent="center">
                    <Grid size={4}>
                        <TextField
                            id="movieName"
                            label="Movie Name"
                            variant="outlined"
                            slotProps={{
                                inputLabel: {
                                    shrink: true,
                                },
                            }}
                            fullWidth
                            value={movieName}
                            onChange={handleMovieNameChange}
                            error={movieNameError}
                            helperText={movieNameHelperText}
                            type="text"
                        />
                    </Grid>
                    <Grid size={4}>
                        <TextField
                            id="directorName"
                            label="Director Name"
                            variant="outlined"
                            slotProps={{
                                inputLabel: {
                                    shrink: true,
                                },
                            }}
                            fullWidth
                            value={directorName}
                            onChange={handleDirectorNameChange}
                            error={directorNameError}
                            helperText={directorNameHelperText}
                            type="text"
                        />
                    </Grid>
                    <Grid size={4}>
                        <FormControl style={{minWidth: 200}}>
                            <InputLabel id="genre-select-label">Genre</InputLabel>
                            <Select
                                labelId="genre-select-label"
                                id="genre-simple-select"
                                value={genre}
                                label="Genre"
                                onChange={handleGenreChange}
                            >
                                {genres.map((option) => (
                                    <MenuItem key={option} value={option}>
                                        {option}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid size={3}>
                        <TextField
                            id="rtmin"
                            label="Minimum Running Time (Mins)"
                            variant="outlined"
                            slotProps={{
                                inputLabel: {
                                    shrink: true,
                                },
                            }}
                            fullWidth
                            value={minRunningTime}
                            onChange={handleMinRunningTimeChange}
                            error={minRunningTimeError}
                            helperText={minRunningTimeHelperText}
                            type="text"
                        />
                    </Grid>
                    <Grid size={3}>
                        <TextField
                            id="rtmax"
                            label="Maximum Running Time (Mins)"
                            variant="outlined"
                            slotProps={{
                                inputLabel: {
                                    shrink: true,
                                },
                            }}
                            fullWidth
                            value={maxRunningTime}
                            onChange={handleMaxRunningTimeChange}
                            error={maxRunningTimeError}
                            helperText={maxRunningTimeHelperText}
                            type="text"
                        />
                    </Grid>
                    <Grid size={3}>
                        <FormControl style={{minWidth: 200}}>
                            <InputLabel id="history-select-label">History</InputLabel>
                            <Select
                                labelId="history-select-label"
                                id="history-simple-select"
                                value={history}
                                label="History"
                                onChange={handleHistoryChange}
                            >
                                <MenuItem value={'All'}>All</MenuItem>
                                <MenuItem value={'Seen'}>Seen</MenuItem>
                                <MenuItem value={'Unseen'}>Unseen</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid size={3}>
                        <Button variant="contained" onClick={handleSearch}>Search</Button>
                    </Grid>
                </Grid>
            </Paper>

            <Paper sx={{ height: 630, width: '100%' }}>
                <DataGrid
                    rows={rows}
                    columns={columns}
                    getRowId={getRowIdFromInternalId}
                    onRowClick={handleRowClick}
                    disableMultipleRowSelection={true}
                    initialState={{ pagination: { paginationModel } }}
                    pageSizeOptions={[5,10]}
                    checkboxSelection
                    sx={{ border: 0 }}
                />
            </Paper>
            <Paper sx={{ flexGrow: 1, width: '100%', padding: 4, marginTop: 2}}>
                <Grid container spacing={2}>
                    <Grid size={3}>
                        <Box
                            component="img"
                            sx={{
                                height: 337,
                                width: 222,
                                //maxHeight: { xs: 400, md: 150 }, // Optional: responsive height
                                //maxWidth: { xs: '100%', md: 250 }, // Optional: responsive max width
                                objectFit: 'cover', // Ensures the image covers the area without stretching
                                borderRadius: '4px', // Optional: adds slight rounding
                            }}
                            alt="Select a movie from the table above"
                            src={imageUrl}
                        />
                    </Grid>
                    <Grid size={9}>
                        <Stack spacing={2}>
                            <TextField
                                id="nominations"
                                label="Nominations"
                                variant="outlined"
                                slotProps={{
                                    inputLabel: {
                                        shrink: true,
                                    },
                                }}
                                fullWidth
                                multiline
                                maxRows={4}
                                value={movie.NominationCategory}
                            />
                            <TextField
                                id="awards"
                                label="Awards"
                                variant="outlined"
                                slotProps={{
                                    inputLabel: {
                                        shrink: true,
                                    },
                                }}
                                fullWidth
                                multiline
                                maxRows={4}
                                value={movie.AwardCategory}
                            />
                            <TextField
                                id="movieOverview"
                                label="Overview"
                                variant="outlined"
                                slotProps={{
                                    inputLabel: {
                                        shrink: true,
                                    },
                                }}
                                fullWidth
                                multiline
                                maxRows={6}
                                value={movie.Overview}
                            />
                        </Stack>
                    </Grid>
                    <Grid size={4}>
                        <TextField
                            id="imdbRating"
                            label="IMDB Rating"
                            variant="outlined"
                            slotProps={{
                                inputLabel: {
                                    shrink: true,
                                },
                            }}
                            fullWidth
                            multiline
                            maxRows={4}
                            value={movie.ImdbScore}
                        />
                    </Grid>
                    <Grid size={4}>
                        <TextField
                            id="rtScore"
                            label="Rotten Tomatoes Rating"
                            variant="outlined"
                            slotProps={{
                                inputLabel: {
                                    shrink: true,
                                },
                            }}
                            fullWidth
                            multiline
                            maxRows={4}
                            value={movie.RtScore}
                        />
                    </Grid>
                    <Grid size={4}>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                label="Date Seen"
                                slotProps={{
                                    field: {
                                        clearable: true,
                                        onClear: handleDateClear,
                                    },
                                    textField: {
                                        InputLabelProps: {
                                            shrink: true, // This keeps the label at the top
                                        },
                                    },
                                }}
                                value={dateSeen}
                                onChange={handleDateChange}
                            />
                        </LocalizationProvider>
                    </Grid>
                </Grid>
            </Paper>
        </Container>

    );
};

export default About;